module.exports = __webpack_public_path__ + "img/max-file-subtract--csv.26e837cb.svg";